module.exports = __webpack_public_path__ + "static/media/std-bg.59946211.png";